<template>
  <base-dialog
    :action="onAction"
    :action-name="'Pause'"
    :cancel-name="'Cancel'"
    :close="onClose"
    :title="'Pause subscription'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-radio-group
            v-model="pause_collection.behavior"
            mandatory
          >
            <v-radio
              class="mb-0"
              color="primary"
              label="Offer services for free"
              value="mark_uncollectible"
            />
            <div class="mb-3 caption grey--text">Invoices will be marked as "Uncollectible"</div>
            <v-radio
              class="mb-0"
              color="primary"
              label="Temporarily offer services for free and collect payment later"
              value="keep_as_draft"
            />
            <div class="mb-3 caption grey--text">Invoices will be kept in "Draft"</div>
            <v-radio
              class="mb-0"
              color="primary"
              label="Unable to provide services"
              value="void"
            />
            <div class="mb-3 caption grey--text">Invoices will be marked as "Void"</div>
          </v-radio-group>
          <v-menu
            v-model="resumesAtMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                clearable
                outlined
                dense
                v-model="pause_collection.resumes_at"
                label="(optional) Resume subscription date"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pause_collection.resumes_at"
              no-title
              @input="resumesAtMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { formatDate, isErrorResponse } from "../../services/util.service"

export default {
  components: { BaseDialog },
  props: {
    id: {
      type: String,
      default: ''
    },
    currentPeriodEnd: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pause_collection: {
        behavior: '',
        resumes_at: null
      },
      resumesAtMenu: false
    }
  },
  methods:{
    ...mapActions([ 'updateSubscription', 'snackSuccess' ]),
    onClose(){
      this.$emit('close')
    },
    onAction() {
      const resumes_at = this.pause_collection.resumes_at
        ? new Date(`${this.pause_collection.resumes_at} 00:00`) / 1000
        : undefined

      const payload = {
        id: this.id,
        pause_collection: {
          behavior: this.pause_collection.behavior,
          resumes_at
        }
      }

      return this.updateSubscription(payload)
        .then(res => {
          if (!isErrorResponse(res)) {
            const successPayload = {
              text: 'Subscription paused'
            }
            this.snackSuccess(successPayload)
            this.$emit('action', payload)
          } else {

          }
          return res
        })
    }
  }
}
</script>
